module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-photo-bouquet-700d1b31fd2c0e10ec9c071b39d936e4.jpg";